
<template lang="html">
    <div class="footerDiv">
        <a class="aMargin footerLinks" v-on:click.prevent="showLicenseAgreement()" href="#">StrinGnosis Software as a Service User Agreement</a>
        <a href="./static/files/StrinGnosisSaaSAgreement.pdf" class="btn" v-b-tooltip title="Download StrinGnosis Software as a Service User Agreement" download>
            <font-awesome-layers class="fa-fw fa-lg">
                <font-awesome-icon icon="file-pdf" class="blade-blue"/>
            </font-awesome-layers>
        </a>
        <span style="margin-left: 20px !important; margin-right: 20px !important;"></span>
        <a class="aMargin footerLinks" v-on:click.prevent="showPrivacyPolicy()" href="#"> Privacy Notice</a>
        <privacy-policy></privacy-policy>
        <license-agreement></license-agreement>
    </div>
</template>

<script>
var pdf = require('../assets/StrinGnosisSaaSAgreement.pdf')
import LicenseAgreement from './LicenseAgreement'
import PrivacyPolicy from './PrivacyPolicy'

export default {
    name: 'license-footer',
    components: { LicenseAgreement, PrivacyPolicy },
    methods: {
        showPrivacyPolicy () {
        this.$eventBus.$emit('show-privacy-policy')
        },
        showLicenseAgreement () {
        this.$eventBus.$emit('show-license-agreement')
        }
        /* ,
        showPrivacyPolicyAsNewWindow () {
        let routeUrl = this.$router.resolve({name: 'UserLicenseAgreement'});
        window.open(routeUrl.href, '_blank');
        },
        showUserLicenseAgreementAsNewWindow () {
        let routeUrl = this.$router.resolve({name: 'UserLicenseAgreement'});
        window.open(routeUrl.href, '_blank');
        } */
    }
}
</script>

<style src="../assets/styles.css">

</style>




// WEBPACK FOOTER //
// src/components/LicenseFooter.vue